import { Routes } from '@angular/router';
import { LayoutLandingComponent } from './layout/layouts/landing/landing.component';
import { AuthGuard } from '@mentebonita/core';

export const appRoutes: Routes = [
  {
    path: '',
    component: LayoutLandingComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/marketing/marketing.routes').then(
            (m) => m.MARKETING_ROUTES
          ),
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'account',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/account/account.routes').then((m) => m.accountRoutes),
  },
  {
    path: 'schedule',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/agenda/agenda.routes').then((m) => m.agendaRoutes),
  },
  {
    path: 'meet',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/reunion/reunion.routes').then((m) => m.reunionRoutes),
  },
  {
    path: 'mx',
    component: LayoutLandingComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './features/marketing/home-mx/pages/home-mx.component'
          ).then((m) => m.HomeMxComponent),
      },
      {
        path: 'planes',
        loadComponent: () =>
          import(
            './features/marketing/planes/pages/planes.page'
          ).then((m) => m.PlanesPageComponent),
        data: { country: 'MX', navbar: { mode: 'dark' } },
      },
    ],
  },
  {
    path: 'landing',
    loadChildren: () =>
      import('./features/campaign/campaign.routes').then(
        (m) => m.campaignRoutes
      ),
  },
  {
    path: 'example',
    loadChildren: () =>
      import('./example/example.routes').then((m) => m.EXAMPLE_ROUTES),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./features/error/error.routes').then((m) => m.errorRoutes),
  },
  {
    path: 'assessment/:token',
    loadComponent: () =>
      import('./features/assessment/pages/public-assessment.page').then(
        (m) => m.PublicAssessmentPage
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
